<template>
    <div :class="['burger-menu', {'language-only': languageOnly} ]" @click="displayMobileMenu = true" />
    <Sidebar position="full" v-model:visible="displayMobileMenu" :modal="false" class="mobile-fullscreen-menu">
        <template #header>
            <div class="logo logo-dark" />
        </template>
        <div class="login-buttons" v-if="!loggedIn && !languageOnly">
            <Button @click="register" class="button-primary" data-cy="button-login">{{$t("register")}}</Button>
            <Button @click="login" class="button-primary" data-cy="button-login">{{$t("login")}}</Button>
        </div>
        <div class="logged-in-buttons" v-else-if="!languageOnly">
            <a href="/kandidaten/dashboard">
                <DesktopComputerIcon class="hero-icon" />{{ $t("search.header.dashboard") }}
            </a>
            <Button @click="logout" class="button-text" data-cy="button-logout">{{ $t("logout") }}</Button>
        </div>
    </Sidebar>
</template>

<script setup>
    import { ref, defineProps } from "vue";
    import { DesktopComputerIcon } from "@heroicons/vue/solid";

    const displayMobileMenu = ref(false);
    defineProps(['logged-in', 'language-only']);

    const emit = defineEmits(['login', 'logout', 'register']);

    function login() {
        displayMobileMenu.value = false;
        emit('login');
    }

    function register() {
        displayMobileMenu.value = false;
        emit('register');
    }

    function logout() {
        displayMobileMenu.value = false;
        emit('logout');
    }

</script>

